import { useEffect } from "react";
import { Select } from "antd";
import { User } from "../../api/models";
import useUsers from "../../swr/useUsers";


const UserSingleSelector = (props: {
  onChange?: (users: User | undefined) => void;
  value?: User;
  userLst?: User[];
  style?: any;
}) => {

  const users = useUsers().data;

  const { userLst: propUserLst, onChange, value, style } = props;
  const userLst = propUserLst || users;
  const options = userLst?.sort((a, b) => a.name.localeCompare(b.name)).map(c => ({ label: c.name, value: c.id }));

  return <Select
    style={style}
    onChange={(id) => {
      const selected = userLst?.find(u => u.id === id);
      onChange?.(selected);
    }}
    showSearch
    optionFilterProp="label"
    value={value?.id}
    allowClear
    options={options}
  />

};

export default UserSingleSelector;
